<script lang="ts">


import {translate} from "$lib/i18n";
</script>

<div class="my-12 h-72 lg:h-[660px] bg-cover flex justify-start md:justify-between items-start md:items-center flex-col p-4 md:p-9 rounded-2xl bg-center bg-no-repeat relative" style="background-image: url('/illustrations/tournaments.avifs')">
  <h2 class="text-center text-lg md:text-4xl font-bold gradient-text-fire">{$translate('Forza Spring Gallop Tournament')}</h2>
  <div class="w-full md:relative md:-top-1/4">
    <div class="w-64 -ml-12 md:ml-0 lg:w-[620px] flex">
      <div class="relative">
        <img src="/illustrations/tournament-frame.png" alt="">
        <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex justify-center items-center flex-col lg:gap-4">
          <span class="gradient-text-fire text-sm md:text-2xl font-bold text-nowrap">{$translate('Tournament Prize')}</span>
          <span class="gradient-text-fire text-3xl md:text-7xl font-bold duration-1000 animate-pulse transition-all">€124,000</span>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-wrap gradient-text-fire md:gap-1.5 gap-0 absolute md:bottom-12 bottom-4 left-4">
    <h4 class="text-xs sm:text-base lg:text-xl">Join us for thrilling competitions and grand prizes!</h4>
  </div>
</div>
